import { TextEditor } from '@approvalmax/ui';
import { font } from 'modules/styles';
import styled from 'styled-components';

export const Field = styled.div`
    position: relative;
    display: block;
    margin-bottom: 17px;
`;

export const Label = styled.label`
    margin: 0;
    width: 110px;
    ${font(12, '#5e5c5c', 'semibold')};
    display: inline-block;
    margin-bottom: 4px;
`;

export const StyledTextEditor = styled(TextEditor)`
    flex: 1;
`;

export const ValidationMessage = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    pointer-events: none;
    z-index: 1;
    ${font(12, '#923924', 'semibold')};
`;
